module.exports = __webpack_public_path__ + "static/media/people.2ce35e63.png";